<div id="notifications-sidebar" class="sidebar" [@slideInOut]="mostrado ? 'in' : 'out'" *ngIf="true">
    <div class="sidebar-header">
        <div class="contenedor-titulo">
            <div class="titulo">
                <h3>Notificaciones</h3>
                <!-- <span class="etiqueta">{{contarNuevos()}} nuevos</span> -->
            </div>

            <button class="close-btn" (click)="close()">×</button>
        </div>
        <!-- <div class="subtitulo">
      <span>Marcar todo como leído</span>

      <div class="noleido">
        <span>Ver solo no leídos</span>
        <app-toggle-switch [(checked)]="mostrarSoloNoLeidos" size="small"
          (checkedChange)="refrescarLeidos()"></app-toggle-switch>
      </div>

    </div> -->
    </div>
    <ul class="notificaciones-grupo">
        <li class="notificacion" *ngFor="let notificacion of notifications$ | async">
            <div class="icono">
                <i class="glyphicon glyphicon-user"></i>
                <!-- @if(!notificacion.leido){
        <span class="indicador-leido"></span>
        } -->
            </div>
            <div class="contenido">
                <div class="cabecera">
                    <strong>{{ notificacion.titulo }}</strong>
                    <small>{{ notificacion.fecha | relativeTime }}</small>
                </div>
                <div class="cuerpo">
                    <p [innerHTML]="notificacion.mensaje"></p>
                </div>
            </div>

        </li>
    </ul>
</div>